var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.question.meta.display)?_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"mb-2"},[_vm._v(_vm._s(_vm.question.title))]),_vm._v(" "),(_vm.question.content)?_c('p',[_vm._v(_vm._s(_vm.question.content))]):_vm._e(),_vm._v(" "),_c(_vm.questionHandle,{tag:"component",attrs:{"question":_vm.question},on:{"checkInput":_vm.checkInput}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }